module.exports = require('./tickWrap')
